<template>
  <form-content
    v-bind="$attrs"
    :title="title"
    :occupancy="occupancyOptions"
    :provinces="provinceOptions"
    type="improve"
    :description="description"
    :thanks-buttons="thanksButtons"
    :schema="schema"
  />
</template>

<script>
import FormContent from '@/web/form/FormContent';
import formFields from '@/web/form/formFields';

export default {
  mixins: [formFields],
  components: { FormContent },
  computed: {
    title() {
      return 'Mejorar mi hipoteca actual';
    },
    description() {
      return [
        'Rellena este formulario y uno de nuestros expertos realizará un estudio preciso de tu situación.',
        'En TRIOTECA la magia comienza con viviendas a partir de 70k.',
      ];
    },
    thanksButtons() {
      return ['phone-date'];
    },
    initialPriceField() {
      return {
        ...this.priceField,
        ...{label: '¿Por qué precio compraste la vivienda?'}
      };
    },
    schema() {
      return [
        this.nameField,
        this.surnameField,
        this.phoneField,
        this.emailField,
        this.provinceField,
        this.initialPriceField,
        this.occupancyField,
        this.initialSignatureDateField,
        this.initialYearsField,
        this.amountBorrowedField,
        this.terms,
        this.inform,
        this.buttons,
      ];
    },
  },
};
</script>
